import { createFileRoute } from '@tanstack/react-router'
import { PolicyDetailPage } from '@/components/employee-center/PolicyDetailPage'
import { useEmployeeCenterDashboard } from '@/components/employee-center/EmployeeCenterEmployeeShell'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center/pending-policies_/$templateId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { templateId } = Route.useParams()
  return <PolicyDetailContent policyDocumentId={templateId} />
}

function PolicyDetailContent({ policyDocumentId }: { policyDocumentId: string }) {
  const {
    dashboard,
    onAcknowledge,
    acknowledgePending,
  } = useEmployeeCenterDashboard()

  const policy =
    dashboard.pendingPolicies.find(
      (p) => p.policyDocumentId === policyDocumentId,
    ) ?? null

  return (
    <PolicyDetailPage
      policy={policy}
      onAcknowledge={onAcknowledge}
      acknowledgePending={acknowledgePending}
    />
  )
}
